import StatusIndicator from './component'

export default StatusIndicator
